var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ve-card"},[_c('a',{attrs:{"href":_vm.url,"aria-label":_vm.title}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.title,"loading":"lazy"}})]),_vm._v(" "),_c('div',{staticClass:"ve-card-title"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }